/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A header an auth client sends upstream. Stored values are never returned.
 */
export type AuthClientHeader = {
  /**
   * What the header is for.
   */
  description?: string | undefined;
  /**
   * Whether the client stores a value for this header.
   */
  hasStoredValue: boolean;
  /**
   * Whether a caller must supply the header when it is copied from the request.
   */
  isRequired: boolean;
  /**
   * Whether the stored value is secret.
   */
  isSecret: boolean;
  /**
   * The header name.
   */
  name: string;
  /**
   * The request header the value is copied from, for pass-through headers.
   */
  valueFromRequestHeader?: string | undefined;
};

/** @internal */
export const AuthClientHeader$inboundSchema: z.ZodMiniType<
  AuthClientHeader,
  unknown
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    has_stored_value: z.boolean(),
    is_required: z.boolean(),
    is_secret: z.boolean(),
    name: z.string(),
    value_from_request_header: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "has_stored_value": "hasStoredValue",
      "is_required": "isRequired",
      "is_secret": "isSecret",
      "value_from_request_header": "valueFromRequestHeader",
    });
  }),
);

export function authClientHeaderFromJSON(
  jsonString: string,
): SafeParseResult<AuthClientHeader, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthClientHeader$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthClientHeader' from JSON`,
  );
}
